"use strict";

$(window).scroll(function () {
  var sc = $(window).scrollTop();
  if (sc > 1000) {
    $("#goTop").show();
  } else {
    $("#goTop").hide();
  }
});
$("#goTop").click(function () {
  var sc = $(window).scrollTop();
  $('body,html').animate({ scrollTop: 0 }, 500);
});


//////////////////
// WEBPACK FOOTER
// ./src/js/goTop.js
// module id = 81
// module chunks = 4